var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUserVoice = function SvgUserVoice(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20.287 1.495a.75.75 0 1 0-1.108 1.01C20.499 3.952 21.25 5.927 21.25 8s-.752 4.048-2.071 5.495a.75.75 0 1 0 1.108 1.01C21.871 12.77 22.75 10.428 22.75 8s-.88-4.77-2.463-6.505M17.554 4.49a.75.75 0 1 0-1.108 1.011c.593.651.937 1.547.937 2.495 0 .947-.343 1.843-.937 2.494a.75.75 0 1 0 1.108 1.011c.858-.94 1.33-2.202 1.33-3.505s-.472-2.565-1.33-3.506"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.5 4.25C7.01 4.25 5 6.282 5 8.778s2.01 4.528 4.5 4.528S14 11.273 14 8.778c0-2.496-2.01-4.528-4.5-4.528m-3 4.528c0-1.678 1.348-3.028 3-3.028s3 1.35 3 3.028-1.348 3.028-3 3.028-3-1.35-3-3.028",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.75 15.583c-1.195 0-2.34.479-3.184 1.329-.843.849-1.316 2-1.316 3.2V22a.75.75 0 0 0 1.5 0v-1.889c0-.805.317-1.575.88-2.143a2.99 2.99 0 0 1 2.12-.885h7.5c.794 0 1.556.318 2.12.885.563.568.88 1.338.88 2.143V22a.75.75 0 0 0 1.5 0v-1.889c0-1.199-.473-2.35-1.316-3.2a4.49 4.49 0 0 0-3.184-1.328z"
  })));
};
export default SvgUserVoice;